"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _kx = require("@/api/kx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'KxLevel',
  data: function data() {
    return {
      activeZone: '1',
      configLoading: false,
      configList: [],
      editDialogVisible: false,
      editForm: {},
      userActiveZone: '1',
      userLoading: false,
      userList: {
        data: [],
        total: 0
      },
      userSearch: {
        uid: '',
        phone: '',
        zoneType: '1',
        page: 1,
        limit: 20
      }
    };
  },
  mounted: function mounted() {
    this.loadConfig();
    this.getUserList();
  },
  methods: {
    loadConfig: function loadConfig() {
      var _this = this;
      this.configLoading = true;
      (0, _kx.kxLevelConfigListApi)().then(function (res) {
        var zoneType = parseInt(_this.activeZone);
        _this.configList = (res || []).filter(function (item) {
          return item.zoneType === zoneType;
        }).sort(function (a, b) {
          return a.sort - b.sort;
        });
        _this.configLoading = false;
      }).catch(function () {
        _this.configLoading = false;
      });
    },
    handleEditConfig: function handleEditConfig(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
    },
    handleSaveConfig: function handleSaveConfig() {
      var _this2 = this;
      (0, _kx.kxLevelConfigUpdateApi)(this.editForm).then(function () {
        _this2.$message.success('保存成功');
        _this2.editDialogVisible = false;
        _this2.loadConfig();
      });
    },
    getUserList: function getUserList(num) {
      var _this3 = this;
      this.userLoading = true;
      this.userSearch.page = num || this.userSearch.page;
      // 根据当前激活的tab设置zoneType
      this.userSearch.zoneType = this.userActiveZone;
      (0, _kx.kxLevelUserListApi)(this.userSearch).then(function (res) {
        _this3.userList.data = res.list || [];
        _this3.userList.total = res.total || 0;
        _this3.userLoading = false;
      }).catch(function () {
        _this3.userLoading = false;
      });
    },
    handleResetUser: function handleResetUser() {
      this.userSearch = {
        uid: '',
        phone: '',
        zoneType: this.userActiveZone,
        page: 1,
        limit: 20
      };
      this.getUserList(1);
    },
    userPageChange: function userPageChange(page) {
      this.userSearch.page = page;
      this.getUserList();
    },
    handleUserSizeChange: function handleUserSizeChange(val) {
      this.userSearch.limit = val;
      this.getUserList();
    }
  }
};